// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { useCallback } from 'react'
import { useModalContext } from 'components/ModalContext'
import { throwSubmissionError } from 'helpers/reduxFormFunctions'
import handleCallsignCascadeSubmit from '../helpers/handleCallsignCascadeSubmit'

const useCallsignCascade = handleSuccessfulSubmitCallback => {
  const { closeContextModal } = useModalContext()

  return useCallback(async (formValues, dispatch) => {
    try {
      const triggerCallback = await dispatch(handleCallsignCascadeSubmit(formValues))

      if (triggerCallback) {
        handleSuccessfulSubmitCallback()
      }

      closeContextModal()
    } catch (err) {
      console.warn(err)
      throwSubmissionError(err)
    }
  }, [])
}

export default useCallsignCascade
